import $ from 'domtastic'




/* BROWSER
----------------------------------------------------------------------------------------------------*/

export default class Browser {

    constructor() {
        this.supports = {}
        this.$html = $('html')

        const P  = navigator.platform
        const UA = navigator.userAgent
        const AV = navigator.appVersion


        // UA Sniffing
        this.isMobile  = (/iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(UA))
        this.isDesktop = !this.isMobile

        this.isChrome    = UA.indexOf('Chrome') > -1
        this.isExplorer  = UA.indexOf('MSIE') > -1
        this.isIE10      = AV.indexOf('MSIE 10') > -1
        this.isEdge      = /(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:|\bEdge\/)(\d+)/.test(UA)
        this.isFirefox   = UA.indexOf('Firefox') > -1
        this.isSafari    = UA.indexOf('Safari') > -1
        this.isOpera     = UA.indexOf('Presto') > -1 || UA.indexOf('OPR/') > -1
        this.isAndroid   = UA.toLowerCase().indexOf('android') > -1
        this.isiOS       = UA.match(/(iPad|iPhone|iPod)/g) || (P === 'MacIntel' && navigator.maxTouchPoints > 1)
        this.isMacOS     = UA.toLowerCase().indexOf('mac') > -1
        this.isWindows   = P.indexOf('Win') > -1
        this.isWindows10 = UA.indexOf('Windows NT 10.0') > -1


        // IE + Edge voodoo
        if (this.isEdge && UA.indexOf('Trident/') > -1) {
            this.isEdge = false
            this.isIE11 = true
        }

        if (this.isExplorer && !this.isIE10) {
            this.isIE9 = true
            this.isIE11 = false
        }

        if (this.isIE9 || this.isIE10 || this.isIE11 || this.isEdge) {
            this.annoying = true
        }

        if (this.isE9 || this.isIE10 || this.isIE11) {
            this.isExplorer = true
        }

        if (this.isIE10) {
            this.isIE11 = false
        }

        if (this.isiOS) {
            this.isMacOS = false
            const start = UA.indexOf('OS ')
            this.iOSVersion = window.Number(UA.substr(start + 3, 3).replace('_', '.'))

            this.isFirstPartyiOSSafari = (UA.indexOf('CriOS') < 0 && UA.indexOf('FxiOS') < 0)
        }


        // Specificities
        if (this.isChrome && this.isSafari) { this.isSafari = false }
        if (this.isChrome && this.isEdge) { this.isChrome = false }
        this.isSafariDesktop = (!this.isMobile && this.isSafari)


        this.isiPad   = (/iPad/i.test(UA)) || (P === 'MacIntel' && navigator.maxTouchPoints > 1)
        this.isiPhone = (/iPhone|iPod/i.test(UA))
        this.isWebApp = navigator.standalone


        this.isDevice = this.isMobile || this.isiOS


        // 💩
        this.hasShittyEmoji = !this.isiOS && !this.isMacOS


        this.addBrowserClass()
        this.detectFeatures()
        this.watchFavicon()
    }




    /* Actions
    --------------------------------------------------------- */

    addBrowserClass() {
        const { $html } = this

        if (this.isWindows) $html.addClass('windows')
        if (this.isMobile || this.isiOS) $html.addClass('mobile')
        if (this.isDevice) $html.addClass('device')
        if (this.isAndroid) $html.addClass('android')

        if (this.isiOS) {
            $html.addClass('iOS')

            if (this.iOSVersion) {
                $html.addClass(`iOS${this.iOSVersion.toString().split('.')[0]}`)

                if (this.iOSVersion >= 15 && this.isFirstPartyiOSSafari) {
                    $html.addClass('has-annoying-ui')
                }
            }
        }

        if (this.isFirefox)  $html.addClass('firefox')
        if (this.isSafari)   $html.addClass('safari')
        if (this.isChrome)   $html.addClass('chrome')
        if (this.isExplorer) $html.addClass('ie')
        if (this.isEdge)     $html.addClass('edge')
        if (this.isIE9)      $html.addClass('ie9')
        if (this.isIE10)     $html.addClass('ie10')
        if (this.isIE11)     $html.addClass('ie11')

        if (this.isIE9 || this.isIE10 || this.isIE11) $html.addClass('ie')

        if (this.isWindows10) $html.addClass('w10')
        if (this.isWebApp) $html.addClass('webapp')

        if (this.hasShittyEmoji) $html.addClass('shitty-emoji')

        $html.removeClass('preload')
    }


    watchFavicon() {
        this.$manifest = $('link[rel="manifest"]')
        this.$favlinks = $('link[rel*="icon"][media]')

        this.$favlinks.forEach((l) => {
            const query = window.matchMedia(l.media)

            this.switchFavicon(query.matches, l)

            query.addListener(({ matches }) => {
                this.switchFavicon(matches, l)
            })
        })
    }


    switchFavicon(matches, icon) {
        $(icon).remove()

        if (matches) {
            this.$manifest[0].parentNode.insertBefore(icon, this.$manifest[0].nextSibling)
        }
    }


    async detectFeatures() {
        const { $html } = this
        const mqReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
        let supportsPassive = false

        try {
            const opts = Object.defineProperty({}, 'passive', {
                get: () => {
                    supportsPassive = true
                },
            })

            window.addEventListener('test', null, opts)
        } catch (e) {
            //
        }

        this.supports.passive = supportsPassive
        this.supports.WebP = await isWebPSupported()

        this.passiveEvent = (this.supports.passive) ? { passive: true } : false
        this.activeEvent = (this.supports.passive) ? { passive: false } : false
        this.reducedMotion  = mqReducedMotion.matches

        $html.toggleClass('focus-within', isSelectorSupported('.yolo:focus-within'))

        $html.addClass(this.supports.WebP ? 'webp' : 'no-webp')
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */

const isSelectorSupported = (selector) => {
    const doc  = document
    const root = doc.documentElement
    const head = doc.head || root
    const style = doc.createElement('style')

    head.insertBefore(style, head.firstChild)
    const { sheet } = style

    try {
        sheet.insertRule(`${selector}{}`, 0)
        sheet.deleteRule(0)

        style.parentNode.removeChild(style)
        return true
    } catch (e) {
        style.parentNode.removeChild(style)
        return false
    }
}


const isWebPSupported = async () => {
    if (!self.createImageBitmap) return false

    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA='
    const blob = await fetch(webpData).then(r => r.blob())
    return createImageBitmap(blob).then(() => true, () => false)
}



